export const masterFirebaseConfig = {
  apiKey: "AIzaSyAFc33ZQtgRSSHT3cfSAA4FDM5I4KWCCzI",
  authDomain: "massahcollection.firebaseapp.com",
  databaseURL: "https://massahcollection.firebaseio.com",
  projectId: "massahcollection",
  storageBucket: "massahcollection.appspot.com",
  messagingSenderId: "36370559819"
};



// WEBPACK FOOTER //
// ./src/app/api-keys.ts